import React from "react"
class Average extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            serie_30 : "",
            serie_60 : "",
            serie_90 : "",
            serie_120 : "",
            serie_120_more : ""
        }
    }

    componentWillReceiveProps(props){
        let char_keys = Object.keys(props.response_request);
        let $self = this;
        let series
        if (char_keys.length > 0){
            series  = props.response_request["result"]["data_average"];
            Object.keys($self.state).map(function(key_serie){
                const serie_item = series[key_serie]["prom"];
                $self.state[key_serie] = Object.keys(serie_item).map(function(key_value){
                    let title;
                    let current_value   = serie_item[key_value]["value"];
                    let last_value      = serie_item[key_value]["lastyear_value"];
                    let comp            = serie_item[key_value]["comp"];

                    if(key_value === "adv_book"){
                        
                        title           = "ADV. BOOK PROM";
                        current_value   = current_value + " DÍAS";
                        last_value      = last_value + " DÍAS";

                    }else if(key_value === "tariff_adr"){
                        title           = "TARIFA PROM";
                        current_value   = "$ " + current_value;
                        last_value      = "$ " + last_value;

                    }else if(key_value === "room_nights"){
                        title = "CUARTOS NOCHE";
                    }else{
                        title = "RESERVACIONES";
                    }
                    let is_better = parseFloat(comp) !== 0 ? (parseFloat(comp) < 0 ? "worst" : "best") : "hide"
                    return (
                        <div className="avg-wdg">
                            <span className="title">{ title }</span>
                            <span className="highlight-title">{ current_value }</span>
                            <div className="footer">
                                <div className="block-1">
                                    <span className="last-year">AÑO PASADO</span>
                                    <span className="highlight-last-year">{ last_value }</span>
                                </div>
                                <div className="block-2">
                                    <span className={"rate-type " + is_better}></span>
                                    <span className="highlight-rate">
                                        { comp }%
                                    </span>
                                </div>
                            </div>
                        </div>
                    )
                })
            });
        }
    }

    render() {
        return (
            <div className="container-adr">
                <div className={"avg-review "}>
                    <div className="head">
                        <span>DE 1 A 30 NOCHES</span>
                    </div>
                    {this.state.serie_30}
                </div>
                <div className={"avg-review "}>
                    <div className="head">
                        <span>DE 31 A 60 NOCHES</span>
                    </div>
                    {this.state.serie_60}
                </div>
                <div className={"avg-review "}>
                    <div className="head">
                        <span>DE 61 A 90 NOCHES</span>
                    </div>
                    {this.state.serie_90}
                </div>
                <div className={"avg-review "}>
                    <div className="head">
                        <span>DE 91 A 120 NOCHES</span>
                    </div>
                    {this.state.serie_120}
                </div>
                <div className={"avg-review "}>
                    <div className="head">
                        <span>DE +120 NOCHES</span>
                    </div>
                    {this.state.serie_120_more}
                </div>
            </div>
        )
    }
}

export default Average



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/views/Average.js